// Panoya kopyalama yardımcısı: güvenli bağlamda Clipboard API kullanılır;
// iframe / eski tarayıcı / izin yok senaryolarında geçici textarea +
// execCommand yedeğine düşer. Başarıda true döner.
const copyTextToClipboard = async (text) => {
  if (!text) return false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    // yedeğe düş
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = String(text);
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (e) {
    return false;
  }
};

export default copyTextToClipboard;
